import axios from '@/libs/api.request'

/**
 * 获取简章列表
 * @param {Object} params 查询参数
 * @param {Number} params.page 页码
 * @param {Number} params.limit 每页数量
 * @param {String} params.title 标题
 * @param {String} params.state 状态（0草稿/1发布）
 */
export const getJianzhangList = params => {
  return axios.request({
    url: '/v1/jianzhang/list',
    method: 'get',
    params
  })
}

/**
 * 获取简章详情
 * @param {Number} id 简章ID
 */
export const getJianzhangDetail = id => {
  return axios.request({
    url: '/v1/jianzhang/detail',
    method: 'get',
    params: { id }
  })
}

/**
 * 新增简章
 */
export const addJianzhang = data => {
  return axios.request({
    url: '/v1/jianzhang/add',
    method: 'post',
    data
  })
}

/**
 * 更新简章
 */
export const updateJianzhang = data => {
  return axios.request({
    url: '/v1/jianzhang/update',
    method: 'put',
    data
  })
}

/**
 * 删除简章
 * @param {Number} id 简章ID
 */
export const deleteJianzhang = id => {
  return axios.request({
    url: '/v1/jianzhang/delete',
    method: 'delete',
    data: { id }
  })
}

/**
 * 获取报名记录
 * @param {Number} exid 简章ID
 */
export const getJianzhangApplies = exid => {
  return axios.request({
    url: '/v1/jianzhang/applies',
    method: 'get',
    params: { exid }
  })
}